initToolTip